import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSuccess$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSuccess extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4bfa2969ec39161263de475c9ced6cf9b840fc6f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c15d2d237bd99411d1221109b3f493bfac837471', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '50a0b95a38a018e3f25f3c8a5f5d07f16bdc4d78', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 18.5a7.5 7.5 0 0 0 7.093-9.944.52.52 0 0 1 .165-.584l.428-.333a.474.474 0 0 1 .741.194 9 9 0 1 1-5.11-5.202c.317.126.388.53.15.774l-.395.408a.52.52 0 0 1-.551.121A7.5 7.5 0 1 0 11 18.5m-3.88-7.62L10 13.72a.49.49 0 0 0 .69-.03l8.88-10.55a.49.49 0 0 0-.06-.7l-.38-.32a.51.51 0 0 0-.71.06l-8.17 9.71-2.07-2.07a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-success", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-success"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-success":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSuccess$1);
            }
            break;
    } });
}

const CosmosIconSuccess = CosmosIconSuccess$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSuccess, defineCustomElement };
